console.log("triiger");
window.showUpsellPopup = function () {
    const popup = document.getElementById("upsell-popup");

    if (!popup) return;

    popup.classList.remove("hidden");
};

// Intercept Shopify Add to Cart requests
(function () {
    const originalFetch = window.fetch;

    window.fetch = async function (...args) {
        const response = await originalFetch.apply(this, args);

        try {
            const url = typeof args[0] === "string" ? args[0] : args[0]?.url;

            if (url && (url.includes("/cart/add") || url.includes("/cart/add.js"))) {

                // Only show on Kuber product pages
                if (window.location.pathname.includes("kuber")) {
                    setTimeout(() => {
                        window.showUpsellPopup();
                    }, 300);
                }
            }
        } catch (e) {
            console.error("Upsell Error:", e);
        }

        return response;
    };
})();

// Close popup
document.addEventListener("click", function (e) {
    if (e.target.matches(".upsell-close") || e.target.matches("#upsell-skip")) {
        document.getElementById("upsell-popup")?.classList.add("hidden");
    }
});

// Add upsell product
document.getElementById("upsell-add")?.addEventListener("click", function () {

    fetch("/cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            id: this.dataset.variantId,
            quantity: 1
        })
    })
    .then(() => {
        document.getElementById("upsell-popup")?.classList.add("hidden");

        // Reload cart drawer/cart count
        document.dispatchEvent(new CustomEvent("cart:refresh"));
    });
});